import { isUnifiedCommerce } from '@shared/constants'
import uzNavigationFunction from '@uz/store/helpers/app-config/uz-navigation.js'
import thNavigationFunction from '@th/store/helpers/app-config/th-navigation.js'

// This function returns the navigation object based on the environment.
export const getNavigation = isUnifiedCommerce()
  ? uzNavigationFunction // UNZER navigation
  : thNavigationFunction // TillHub navigation
